import * as yup from "yup";
import { message } from "../../messages/Message";

const schema = yup.object().shape({
  name: yup
    .string()
    .required(message.nameRequiredMessage)
    .matches(/^[A-Za-z\s]+$/, message.nameMatchMessage),
  companyName: yup.string().required("Company Name is required"),
   websiteUrl: yup
    .string()
    .required("Website URL is required")
    .url("Enter a valid URL"),
  password: yup
    .string()
    .required(message.passwordRequiredMessage)
    .min(8, message.passwordMinMessage)
    .matches(
      /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^\w])[A-Za-z\d\W_]{8,}$/,
      message.passwordMatchMessage
    ),
  terms: yup.bool().oneOf([true], "You must accept the terms"),
});

export default schema;
